"use client"

import * as React from "react"
import { ChevronsUpDown } from "lucide-react"
import { WorkflowStatus } from '@prisma/client';
import { Button } from "@/components/ui/button"
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover"
import { StatusSelectorProps } from "./status-selector.types";

import { Status } from "@/components/ui/status";
import { TransactionContext } from "@/app/report/transactions/context";
import { useContext, useEffect } from "react";
import { TransactionContextType } from "@/app/report/transactions/context";
const StatusSelector: React.FC<StatusSelectorProps> = ({ onChange }) => {
  const [open, setOpen] = React.useState(false)

  const { selectedTransaction } = useContext(TransactionContext) as TransactionContextType;
  const [selectedStatus, setSelectedStatus] = React.useState<WorkflowStatus | null>(selectedTransaction?.workflowStatus || null )

  useEffect(() => {
    setSelectedStatus(selectedTransaction?.workflowStatus || null)
  }, [selectedTransaction?.workflowStatus])

  const handleStatusChange = (status: WorkflowStatus) => {
    setSelectedStatus(status)
    onChange(status)
  }

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className="w-full justify-between"
        >
          {selectedStatus
            ? <Status status={selectedStatus} />
            : "Select a status..."}
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] p-0">
        <Command>
          <CommandInput variant="ghost" className="py-3" placeholder="Search status..." />
          <CommandList>
            <CommandEmpty>No status found.</CommandEmpty>
            <CommandGroup>
              {Object.values(WorkflowStatus).map((status) => (
                <CommandItem
                  key={status}
                  value={status}
                  selected={selectedStatus === status}
                  onSelect={(currentValue) => {
                    handleStatusChange(currentValue as WorkflowStatus)
                      setOpen(false)
                    }}
                  >
                    <Status status={status} />
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  )
}

export { StatusSelector }
